import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/common.css';

/**
 * Reusable loading spinner component
 * @param {Object} props
 * @param {string} props.message - Optional loading message to display
 * @param {string} props.size - Size of the spinner (small, medium, large)
 * @param {boolean} props.overlay - Whether to show as a full-screen overlay
 * @param {boolean} props.transparent - Whether the background should be transparent
 */
const Loading = ({ 
  message = 'Loading...', 
  size = 'medium', 
  overlay = false,
  transparent = false
}) => {
  const spinnerClass = `spinner spinner-${size}`;
  
  if (overlay) {
    return (
      <div className={`loading-overlay ${transparent ? 'transparent' : ''}`}>
        <div className="loading-content">
          <div className={spinnerClass}>
            <div className="spinner-inner"></div>
          </div>
          {message && <p className="loading-message">{message}</p>}
        </div>
      </div>
    );
  }
  
  return (
    <div className="loading-container">
      <div className={spinnerClass}>
        <div className="spinner-inner"></div>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  overlay: PropTypes.bool,
  transparent: PropTypes.bool
};

export default Loading;